package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideMoon
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideSun
import co.maytes.standupbot.dashboard.features.theme.LocalThemeStore
import co.maytes.standupbot.dashboard.features.theme.SystemThemeListener
import co.maytes.standupbot.dashboard.styles.Palette
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.styleModifier

@Composable
fun ThemeToggle(modifier: Modifier = Modifier) {
    val store = LocalThemeStore.current
    SystemThemeListener(store)

    IconButton(
        ariaLabel = "Toggle theme",
        modifier = Modifier
            .backgroundColor(Palette.surface)
            .color(Palette.textPrimary)
            .styleModifier { property("border", "1px solid ${Palette.border.cssRgb()}") }
            .then(modifier),
        onClick = { store.toggleLightDark() },
    ) {
        Box(
            modifier = Modifier
                .classNames("sb-theme-toggle-stack")
                .styleModifier {
                    property("position", "relative")
                    property("width", "20px")
                    property("height", "20px")
                },
            contentAlignment = Alignment.Center,
        ) {
            Box(
                modifier = Modifier
                    .classNames("sb-theme-icon", "sb-theme-moon")
                    .color(Palette.textPrimary),
            ) {
                LucideMoon(size = 18)
            }
            Box(
                modifier = Modifier
                    .classNames("sb-theme-icon", "sb-theme-sun")
                    .color(Palette.textPrimary),
            ) {
                LucideSun(size = 18)
            }
        }
    }
}
